const createNoopUnsubscribe = () => () => {};

const unsupportedAsync = async () => {
  if (typeof console !== 'undefined' && typeof console.warn === 'function') {
    console.warn('[web] @react-native-firebase/messaging is not available; using a no-op mock.');
  }
};

const messagingInstance = {
  registerDeviceForRemoteMessages: unsupportedAsync,
  getToken: async () => '',
  deleteToken: unsupportedAsync,
  getInitialNotification: async () => null,
  onMessage: createNoopUnsubscribe,
  onNotificationOpenedApp: createNoopUnsubscribe,
  onTokenRefresh: createNoopUnsubscribe,
  setBackgroundMessageHandler: () => {},
};

function messaging() {
  return messagingInstance;
}

messaging.AuthorizationStatus = {
  NOT_DETERMINED: -1,
  DENIED: 0,
  AUTHORIZED: 1,
  PROVISIONAL: 2,
  EPHEMERAL: 3,
};

module.exports = messaging;
module.exports.default = messaging;

